import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsPage } from './pages/TermsPage';

export const legalRoutes = [
  { path: 'privacy-policy', element: <PrivacyPolicyPage /> },
  { path: 'terms', element: <TermsPage /> },
];
